<template>
  <div v-if="hasFields" class="mt-1">
    <button
      type="button"
      class="inline-flex items-center gap-1 rounded px-1 py-0.5 font-mono text-xs text-obsidian-600 transition-colors hover:bg-obsidian-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary"
      :aria-expanded="expanded"
      :aria-controls="panelId"
      @click="expanded = !expanded"
    >
      <ChevronRightIcon
        class="size-3.5 shrink-0 transition-transform duration-150"
        :class="{ 'rotate-90': expanded }"
        aria-hidden="true"
      />
      {{ expanded ? t('hideCreatedValues') : t('showCreatedValues') }}
    </button>
    <div v-show="expanded" :id="panelId">
      <ChangedFieldsList :changed-fields="changedFields" />
    </div>
  </div>
</template>

<script setup lang="ts">
import ChangedFieldsList from '@/components/audit-log/ChangedFieldsList.vue';
import type { ChangedFields } from '@carvia/ros-client-types';
import { ChevronRightIcon } from 'lucide-vue-next';
import { computed, ref, useId } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps<{
  changedFields: ChangedFields;
}>();

const { t } = useI18n();
const expanded = ref(false);
const panelId = useId();

const hasFields = computed(() => Object.keys(props.changedFields ?? {}).length > 0);
</script>

<i18n lang="json">
{
  "en": {
    "showCreatedValues": "Show created values",
    "hideCreatedValues": "Hide created values"
  },
  "de": {
    "showCreatedValues": "Erstellte Werte anzeigen",
    "hideCreatedValues": "Erstellte Werte ausblenden"
  },
  "es": {
    "showCreatedValues": "Mostrar valores creados",
    "hideCreatedValues": "Ocultar valores creados"
  }
}
</i18n>
